import { ChevronRight } from "lucide-react";
import Link from "next/link";
import type { ReactNode } from "react";

import { cx } from "./cx";
import styles from "./list-item.module.css";

export interface ListItemProps {
  href?: string;
  onClick?: () => void;
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  trailing?: ReactNode;
  className?: string;
}

export function ListItem({
  href,
  onClick,
  icon,
  title,
  description,
  trailing,
  className,
}: ListItemProps) {
  const resolvedTrailing =
    trailing ?? (href ? <ChevronRight size={16} /> : null);

  const inner = (
    <>
      {icon ? <span className={styles.icon}>{icon}</span> : null}
      <div className={styles.textGroup}>
        <span className={styles.title}>{title}</span>
        {description ? (
          <span className={styles.description}>{description}</span>
        ) : null}
      </div>
      {resolvedTrailing ? (
        <span className={styles.trailing}>{resolvedTrailing}</span>
      ) : null}
    </>
  );

  const rowClass = cx(
    styles.row,
    (href || onClick) && styles.rowInteractive,
    className,
  );

  if (href) {
    return (
      <Link href={href} className={rowClass}>
        {inner}
      </Link>
    );
  }
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={rowClass}>
        {inner}
      </button>
    );
  }
  return <div className={rowClass}>{inner}</div>;
}
